export default __webpack_public_path__ + "static/media/tim-ios-partial-steps.8b3144ad.png";